<template>
  <v-application></v-application>
</template>

<script>
export default {
  name: "Home",
  data: () => ({}),
  beforeMount() {
    if (this.$store.state.user === null) this.$router.push("/signin");
  },
  mounted() {
    this.$store.commit("setNavObj", []);
    const now = new Date();
    const options = {
      start_date: new Date(new Date().setDate(now.getDate() - 7))
        .toISOString()
        .substr(0, 10),
      end_date: new Date(new Date().setDate(now.getDate() + 1))
        .toISOString()
        .substr(0, 10),
      custom: false,
      employee: { name: this.$t("all_employees"), _id: "" },
      reason: {
        name: "All reasons",
        value: "",
      },
      start: { text: "12 AM", time: 0 },
      end: { text: "12 PM", time: 12 },
    };
    this.$store.commit("setOptions", options);
  },
};
</script>
